import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
	}

	og-dropdown {
		height: 100%;
	}

	div[slot="label"] {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	:host([inline]) .helpmenu-content {
		height: auto;
		max-width: none;
		overflow: visible;
	}
`;

export const helpMenuContentStyle = css`
	.helpmenu-content {
		overflow: hidden;
		position: relative;
		min-width: 160px;
		max-width: 220px;
		height: 100%;
		padding: 4px;
	}

	.helpmenu-content og-button,
	.helpmenu-content og-dropdown-menu {
		display: block;
		margin: 2px 5px;
	}

	.helpmenu-content og-icon {
		margin-right: 5px;
	}

	.helpmenu-content .section {
		display: flex;
		justify-content: space-evenly;
		margin-top: 5px;
		border-top: 1px solid gray;
		flex-wrap: wrap;
	}

	.helpmenu-content .section .section-label {
		position: absolute;
    	left: 4px;
    	font-size: 8px;
	}

	.helpmenu-content .section .section-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 5px;
		margin: 15px 5px 5px 9px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.helpmenu-content .section .section-info span {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.helpmenu-content .section og-button {
		display: inline-flex;
		margin-top: 15px;
	}
`;
